<div class="dialog" data-testid="dialog-token-generate">
    <div class="dialog-header">
        <h2>{{ 'shared.dialog.token-generate.heading'  | translate }}</h2>
        <a class="dialog-close" (click)="onCancel()" data-testid="dialog-token-generate-close">&times;</a>
    </div>
    <div class="dialog-body">
        <div class="form-row">
            <label>{{ 'shared.label.type' | translate }}</label>

            <select name="role" [(ngModel)]="model.role" data-testid="dialog-token-generate-role-select">
                <option *ngFor="let role of roles" [value]="role">
                    {{ 'technicals.tokens.role.' + role | translate }}
                </option>
            </select>
        </div>

        <div class="form-row">
            <label>{{ 'shared.label.description' | translate }}</label>
            <input type="text" required name="comment" maxlength="20" [(ngModel)]="model.comment" data-testid="dialog-token-generate-description-input">
        </div>

        <div class="buttons buttons-flex">
            <a class="button button-basic-primary" (click)="onCancel()" data-testid="dialog-token-generate-cancel-btn">{{ 'shared.button.cancel' | translate }}</a>
            <a class="button button-primary" (click)="onConfirm()" data-testid="dialog-token-generate-confirm-btn">{{ 'shared.button.confirm' | translate }}</a>
        </div>
    </div>
</div>
